// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "AdditionalInfoCard-module--wrapper--Alkgd";
export var icon = "AdditionalInfoCard-module--icon--LNnrg";
export var title = "AdditionalInfoCard-module--title--Om5rR";
export var body = "AdditionalInfoCard-module--body--n8hWT";